import { Badge as MUIBadge, BadgeProps } from '@mui/material';
import styles from './badge.module.css';

function Badge(props: BadgeProps) {
  return (
    <MUIBadge
      classes={{
        badge: styles.topbarCartBadge,
      }}
      max={999999}
      showZero
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    />
  );
}

export default Badge;
